import React from 'react';
import { Node } from 'src/common/interfaces/node.interface';
import { Journey } from 'src/common/interfaces/journey.interface';
import UnorderedListIconBase64 from 'src/icons/unordered-list.svg';

import { PlayerNavigationMobileCard } from './mobile-card';
import { PlayerAiAssistantButton } from '../components';

interface PlayerNavigationMobileTopProps {
  currentNode: Node;
  journey: Journey;
  onClickMenu: () => void;
}

export const PlayerNavigationMobileTop = ({ currentNode, journey, onClickMenu }: PlayerNavigationMobileTopProps) => {
  if (!currentNode) return null;
  if (currentNode.content_type === 'journey_upsell') return null;

  return (
    <div className='flex items-center justify-between md:hidden my-4'>
      <PlayerNavigationMobileCard hideBubble node={currentNode} containerClassName='items-center' />
      <div className='flex items-center space-x-2'>
        <PlayerAiAssistantButton journey={journey} />
        <img src={UnorderedListIconBase64} alt='' className='shrink-0' onClick={onClickMenu} />
      </div>
    </div>
  );
};
